import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingCrack1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.86 3.045h1.52v9.15h-1.52Zm-1.52 9.15h1.52v3.04h-1.52Zm-1.53 3.04h1.53v1.53h-1.53Z\"/><path fill=\"currentColor\" d=\"M12.19 16.765v1.52h3.05v6.1h-4.57v1.52H9.15v3.05h1.52v1.52h10.67v-1.52h1.52v-3.05h-1.52v-1.52h-4.58v-6.1h3.05v-1.52zm3.05-7.62h1.52v1.52h-1.52Zm0-3.05h-1.52v1.53h3.04v1.52h1.53v-3.05h-1.53v-1.52h-1.52zm-1.52 4.57h1.52v1.53h-1.52Zm-3.05 4.57h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 3.045v1.53h1.53v-1.53h4.57v-1.52H9.15v1.52zm-7.61 9.15h1.52v3.04H9.15Zm-1.53-9.15h1.53v9.15H7.62Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingCrack1
